<template>
  <v-container style="height: 95vh !important;" fluid>
    <lottie v-if="loading" :options="lottieOptions" :height="250" :width="250" />
    <v-row v-else style="height: 100%" align="center" justify="center">
      <router-view />
    </v-row>
  </v-container>
</template>

<script>
import * as animationData from '@/assets/animations/loading.json';
import { mapMutations, mapActions } from 'vuex';
import WhitelabelRepository from '../../repositories/whitelabel'
import CognitoAuthRepository from "../../repositories/cognitoAuth"
import AuthRepository from '../../repositories/auth'
import { Auth } from 'aws-amplify';

export default {
  name: "EmbedIndex",
  data() {
    return {
      loading: true,
      lottieOptions: { animationData: animationData.default, },
    };
  },
  created() {
    let darkMode = new URLSearchParams(window.location.search).get("darkMode");
    if (darkMode && darkMode !="false") {
      this.$vuetify.theme.dark = true;
      this.setCurrentTheme("dark");
    } else {
      this.$vuetify.theme.dark = false;
      this.setCurrentTheme("light");
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    ...mapMutations(['setWhitelabelUtils', 'setCurrentTheme']),
    async init() {
      let embedKey = null
      let userId = null
      let userEmail = null
      let context = null
      let logged = this.$store.state.token !== ''
      if (!logged || this.$route.query.userEmail !== this.$store.state.whitelabel.userEmail) {
        embedKey = this.$route.query.embedKey
        userId = this.$route.query.userId
        userEmail = this.$route.query.userEmail
        context = this.$route.query.context
        if (embedKey && userId && userEmail) {
          if (this.$route.query.userEmail !== this.$store.state.whitelabel.userEmail && logged) await this.signOut()
          this.whitelabelLogin(embedKey, userEmail, userId, context)
        } else {
          alert("whitelabel param undefined")
        }
      } else {
        this.$router.push('/onboard')
      }
    },
    ...mapActions([
      "updateAppThemes"
    ]),
    ...mapMutations(['clearData']),
    async signOut() {
      this.clearData();
      console.log(await Auth.signOut())
    },
    whitelabelLogin(embedKey, userEmail, userId, context) {
      WhitelabelRepository.getWhitelabelByApiKey(embedKey).then(async (res) => {
        if (res.data !== null) {
          // Saves white-labeled data in the store
          let utils = {
            userEmail: userEmail,
            userId: userId,
            partner: res.data.whitelabel.partner,
            embedKey: embedKey,
            features: res.data.features,
            platform: res.data.whitelabel.platform,
            context: context,
            isInvestorPasswordRequired: res.data.whitelabel.investorPasswordRequired
          };

          let appthemes = { light: {}, dark: {} }
          res.data.partnerBrandThemes.map(obj => {
            let type = obj.type.toLowerCase()
            for (const [key, value] of Object.entries(obj)) {
              if (key != "id" && key != "type") {
                appthemes[type][key] = `#${value}`
              }
            }
          })
          if (this.$store.state.currentTheme == "light") {
            utils["partner"]["fullLogoUrl"] = utils["partner"]["fullLogoUrl"] + "-Light.png";
            utils["partner"]["responsiveLogoUrl"] = utils["partner"]["responsiveLogoUrl"] + "-Light.png";
          }
          if (this.$store.state.currentTheme == "dark") {
            utils["partner"]["fullLogoUrl"] = utils["partner"]["fullLogoUrl"] + "-Dark.png";
            utils["partner"]["responsiveLogoUrl"] = utils["partner"]["responsiveLogoUrl"] + "-Dark.png";
          }
          this.updateAppThemes(appthemes);
          this.setWhitelabelUtils(utils);

          // Get cognitoAuth entity by username (using userEmail)
          const isUsernameInCognitoPool = (await CognitoAuthRepository.isUsernameInCognitoPool(userEmail)).data
          if (isUsernameInCognitoPool) { // if not null, proceeds to the passwordlessChecking, which initiates passwordless login flow
            this.$router.push({ name: 'passwordless-checking' })
            this.loading = false;
          } else { // if null, tries to fetch username by using userEmail (in the jhi_user table)
            const username = (await AuthRepository.getUsernameFromEmail(userEmail)).data
            if (username !== null) { // if username is not null, registers the jhiUser in the userpool and in the authCognito table, then proceed to the passwordlessChecking view...
              const result = await CognitoAuthRepository.createCognitoAuthFromSwisetUser(userEmail, userEmail)
              if (!result) {
                alert("Failed registration to Authprovider from existing user")
              } else {
                this.$router.push({ name: 'passwordless-checking' })
                this.loading = false;
              }
            } else { // if username is null, we use a collapsed registration + userPool-authCognito registration, proceed to the passwordlessChecking view and later we land on the remaining user onboarding
              this.$router.push('/embed/introduction')
              this.loading = false;
            }
          }
        }
        else {
          alert("Not-found whitelabel")
        }
      }).catch((err) => {
        if (process.env.NODE_ENV !== 'production') {
          // eslint-disable-next-line no-console
          console.error('Whitelabel load failed:', err && err.message ? err.message : err)
        }
        alert("Error while trying to get whitelabel from apiKey")
      })
    },

  }
}
</script>

<style scoped></style>